import { render, staticRenderFns } from "./User_center.vue?vue&type=template&id=68c50696&scoped=true&"
import script from "./User_center.vue?vue&type=script&lang=js&"
export * from "./User_center.vue?vue&type=script&lang=js&"
import style0 from "./User_center.vue?vue&type=style&index=0&id=68c50696&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c50696",
  null
  
)

export default component.exports